export default {
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Cacher le mot de passe',
};
